<div class="form-field">
    @if(label) {
        <label class="form-field__label">
            {{ label }}
            @if(required) {
                <span class="form-field__required">*</span>
            }
        </label>
    }

<input
    type="number"
    [id]="formControlName"
    [placeholder]="placeholder"
    [pattern]="pattern"
    [required]="required"
    [disabled]="control?.disabled"
    (input)="onInput($event)"
    (blur)="onTouched()"
    [value]="value"
    class="form-field__number form-field__number--{{ size }}"
    [ngClass]="{
        'form-field__number--invalid': isInvalid,
        'form-field__number--disabled': control?.disabled
    }"
/>  

@if (errorMessage) {
    <div class="form-field__error">
        {{ errorMessage }}
    </div>
}
</div>